import { render, staticRenderFns } from "./advancePersonalAddressSettings.vue?vue&type=template&id=66af74a8"
import script from "./advancePersonalAddressSettings.vue?vue&type=script&lang=js"
export * from "./advancePersonalAddressSettings.vue?vue&type=script&lang=js"
import style0 from "./advancePersonalAddressSettings.vue?vue&type=style&index=0&id=66af74a8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports